module.exports = __webpack_public_path__ + "static/media/bulletin.003713a9.svg";